var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"circle-1"}}),_c('div',{style:({backgroundImage: `url(${_vm.getLoadingPic})`}),attrs:{"id":"circle-2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }